/*
  Loose Labels (clj to js)
  ---
  Released under the MIT License.
  Codebase: https://github.com/rm-hull/loose-labels.git

  @author: mk.ko
 */

export function niceNumber (x, round = false) {
  try {
    if (!(x >= 0)) {
      return
    }

    let
      exp = Math.floor(Math.log10(x)),
      d = Math.pow(10, exp),
      f = x / (d === 0 ? 1 : d),
      nf = 10

    if (round) {
      if (f < 1.5) {
        nf = 1.0
      } else if (f < 3.0) {
        nf = 2.0
      } else if (f < 7.0) {
        nf = 5.0
      } else {
        nf = 10.0
      }
    } else {
      if (f <= 1.0) {
        nf = 1.0
      } else if (f <= 2.0) {
        nf = 2.0
      } else if (f <= 5.0) {
        nf = 5.0
      } else {
        nf = 10.0
      }
    }

    return nf * Math.pow(10, exp)
  } catch (e) {
    return void 0
  }
}

export function looseLabel (lower, upper, ntick = 5) {
  try {
    if (!(ntick >= 2)) {
      return
    }
    if (!(lower < upper)) {
      return
    }

    let
      rng = niceNumber((upper - lower), false),
      d = niceNumber((rng / --ntick), true),
      graphmin = Math.floor(lower / d) * d,
      graphmax = Math.ceil(upper / d) * d,
      nfrac = parseInt(Math.max(-Math.floor(Math.log10(d)), 0)),
      fmtMeta = function (value) {
        return parseFloat(value).toFixed(nfrac)
      }

    let range = []
    let graphmaxRange = graphmax + (0.5 * d)
    for (let i = 0; i < graphmaxRange; (i += d)) {
      let pushData = graphmin + i
      if (pushData <= graphmaxRange) {
        range.push(pushData)
      } else {
        break
      }
    }

    let res = range.map(fmtMeta)

    return res
  } catch (e) {
    return void 0
  }
}

export function values (labels) {
  try {
    return labels.map(label => parseFloat(label))
  } catch (e) {
    return void 0
  }
}
